import { api } from "..";
import { QueryProps } from "@/types/Api";
import { ChatMessagesResponse, GetChatMessagesParams } from "./types";

export const getChatMessages = async (
  props: QueryProps<GetChatMessagesParams>
): Promise<ChatMessagesResponse> => {
  const { chatId } = props.params;
  const res = await api.client.get(`/chats/${chatId}/messages`, {
    signal: props.signal,
  });
  return res.data;
};
